import { useGlobalVariables } from '../../context/globalConfig/securedConfigHook';
import { useUser } from '../../context/user';

export function useIsCopilotEnabled() {
  const userData = useUser();
  const isCopilotEnabled = useGlobalVariables().isClusterLevelCopilotEnabled && !!userData?.user?.copilotEnabled;

  return isCopilotEnabled;
}
